import { setupAuthLifecycle } from './api/auth'
import { setupHttp } from './api/http'
import { setupSettingsSyncLifecycle } from './api/settings'
import { getUser } from './api/user'
import { setupNativeDiscogsOAuth } from './auth/discogsAuth'
import { IS_NATIVE_APP } from './config/environment'
import { navigateTo } from './router'
import { clearCollectionQueryCache } from './stores/collectionStore'
import { setupSwitchHaptics } from './utils/haptics'
import { updateActiveNavItem } from './utils/navState'
import { applyTheme } from './utils/theme'

window.addEventListener('resize', () => {
	updateActiveNavItem(window.location.pathname)
})

window.addEventListener('popstate', () => {
	void navigateTo(window.location.pathname)
})
document.addEventListener('DOMContentLoaded', () => {
	void initializeClient()
})

async function initializeClient(): Promise<void> {
	history.scrollRestoration = 'manual'
	// Browser reload is the web refresh action; do not reuse persisted query pages.
	if (!IS_NATIVE_APP) clearCollectionQueryCache()
	setupHttp()
	setupPublicRouteLinks()
	setupSwitchHaptics()
	await setupNativeDiscogsOAuth()
	setupAuthLifecycle()
	setupSettingsSyncLifecycle()
	const user = await getUser()
	applyTheme(user?.settings?.theme === 'light')
	await navigateTo(window.location.pathname)
}

/** Keeps public-info links inside the SPA and native WebView. */
function setupPublicRouteLinks(): void {
	document.addEventListener('click', (event) => {
		if (
			event.defaultPrevented ||
			event.button !== 0 ||
			event.metaKey ||
			event.ctrlKey ||
			event.shiftKey ||
			event.altKey
		) {
			return
		}

		const target = event.target
		if (!(target instanceof Element)) return
		const link = target.closest<HTMLAnchorElement>('a[data-public-route]')
		if (!link) return

		const url = new URL(link.href, window.location.href)
		if (url.origin !== window.location.origin) return
		event.preventDefault()
		history.pushState({}, '', url.pathname)
		void navigateTo(url.pathname)
	})
}
